export default "__VITE_ASSET__DKs$V9P0__"